







"use strict";




function objectAssign(o1, ...os) {
    for (let o2 of os) {
        for (let key of Object.keys(o2 || {})) {
            o1[key] = o2[key];
        }
    }
    return o1;
}

function safeString(value) {
    return (value && value.toString()) || "";
}

const XUX_DEFAULT_ITEMSPERPAGE = 20;
const XUX_DEFAULT_PAGESPERLOAD = 3;
const CACHE_PAGING_METHOD = ["noCache", "noPaging", "unindexed"];









class XuxTableSupport {
    










    
































    














    















































    constructor(params ) {
        
        if (arguments.length > 1) { 
            params = {};
            let names = ["elem", "l10n", "columns", "supportOptions", "xuxOptions"];
            for (let i = 0; i < arguments.length; i++) {
                params[names[i]] = arguments[i]; 
            }
        }
        let {elem, l10n, columns, supportOptions = {}, xuxOptions = {}} = params;

        this.options = objectAssign({
            emptyFormatter: data => data ? data : "",
            arrayFormatter: data => data.join(" ")
        }, supportOptions);

        this.elem = elem;
        let decorated = elem.get(0).id.toUpperCase() !== "TABLE";
        this._xuxWidgetName = decorated ? "xuxDecoratedTable" : "xuxTable";
        let tableElem = decorated ? $("table", elem) : elem;
        this.xuxOptions = xuxOptions;

        if (xuxOptions.selectionControl && xuxOptions.selectionControl !== "none") {
            columns = objectAssign({"_selectionControl": {_noQuery: true, width: "fitContent"}},
                                   columns);
        }

        
        this._cachePagingInit();

        this.columns = columns;
        this.columnKeys = Object.keys(columns);
        this.queryColumnKeys = this.columnKeys.filter(key => !columns[key]._noQuery)
            .map(key => columns[key]._accessPath || key);
        this.queryColumnKeyIdxs = this.queryColumnKeys.reduce((obj, key) => {
            obj[key] = Object.keys(obj).length;
            return obj;
        }, {});
        this.accessPathMap = this.columnKeys.reduce((obj, key) => {
            let path = columns[key]._accessPath;
            if (path) {
                obj[path] = key;
            }
            return obj;
        }, {});
        this.defaultSortKey = undefined;

        this.xuxColumns = [];
        for (let i = 0; i < this.columnKeys.length; ++i) {
            let key = this.columnKeys[i];
            let column = columns[key];
            if (column._hidden) {
                continue;
            }
            let c = Object.keys(column).reduce((obj, prop) => {
                obj[prop] = column[prop];
                return obj;
            }, {field: key});
            column._idx = this.xuxColumns.length;
            this.xuxColumns.push(c);

            if (!key.startsWith("_") && (!this.defaultSortKey || column._defaultSort)) {
                this.defaultSortKey = key;
            }
        }

        function getColumnLoalizedName(key) {
            let info = columns[key];
            return key.startsWith("_") ? "" : l10n
                ? (() => {
                    let value = l10n.format(info._localizationLabel || key);
                    return value === null ? key : value;
                })() : key;
        }

        $("thead", tableElem).append(
            this.columnKeys.filter(key => !this.columns[key]._hidden)
                .reduce((tr, key) => {
                    let th = $("<th>").text(getColumnLoalizedName(key));
                    tr.append(th);
                    return tr;
                }, $("<tr>")));
    }

    






    processData(data, param) {
        
        data.fields = data.fields.map(field => this.accessPathMap[field] || field);
        let fields = data.fields;
        data.items.forEach(item => {
            (!item._original) && (item._original = {});
            for (let i = 0; i < fields.length; ++i) {
                let column = this.columns[fields[i]];
                let original = item.getOriginalByIdx(i);
                let value = original;
                if ("_formatter" in column) {
                    value = column._formatter(value, item);
                }
                if (!value && this.options.emptyFormatter) {
                    value = this.options.emptyFormatter(value, item);
                } else if (value && Array.isArray(value) && this.options.arrayFormatter) {
                    value = this.options.arrayFormatter(value, item);
                }
                item[i] = value;
                if (original !== value) {
                    item._original[i] = original;
                }
            }
        }, this);

        
        let search = (param && param.search);
        if (search && this.options.enableBrowserfilter) {
            data.items = data.items.filter(item =>
                item.some(value => safeString(value).indexOf(search) !== -1)
            );
        }

        
        let sortCond = (param && param.sort) || {
            field: this.defaultSortKey,
            order: this.columns[this.defaultSortKey].defaultSortOrder
        };
        let idx = this.queryColumnKeyIdxs[
            this.columns[sortCond.field]._accessPath || sortCond.field];
        let sortByBeforeFormat = this.columns[sortCond.field]._sortByBeforeFormat;
        data.items.sort((a, b) => {
            if (sortCond.order !== "asc") {
                [a, b] = [b, a];
            }
            let av = sortByBeforeFormat && idx in a._original ? a._original[idx] : a[idx];
            let bv = sortByBeforeFormat && idx in b._original ? b._original[idx] : b[idx];
            if (av < bv) {
                return -1;
            } else if (av > bv) {
                return 1;
            }
            return 0;
        });
        return data;
    }

    





    init(xuxOptions) {
        let options = objectAssign({
            sortOptions: {
                column: this.columns[this.defaultSortKey]._idx,
                order: this.columns[this.defaultSortKey].defaultSortOrder
            },
            columns: this.xuxColumns
        }, xuxOptions || this.xuxOptions);
        this.elem[this._xuxWidgetName](options);
        this.widget = this.elem.data(`xux-${this._xuxWidgetName}`);
    }

    







    createQueryUrl(url) {
        let sep = (url.indexOf("?") === -1) ? "?" : "&";
        return `${url}${sep}columns=${encodeURIComponent(this.queryColumnKeys.join(":"))}`;
    }

    









    toSimpleAccessPath(items) {
        let isArray = Array.isArray(items);
        for (let item of (isArray ? items : [items])) {
            for (let key of Object.keys(item)) {
                if (key.indexOf["."] !== -1 || key.indexOf["["] !== -1) {
                    let simpleKey = this.accessPathMap[key];
                    if (!simpleKey) {
                        let columnDef = this.columns[key];
                        if (columnDef) {
                            simpleKey = columnDef._localizationLabel;
                        }
                    }
                    if (simpleKey) {
                        item[simpleKey] = item[key];
                        delete item[key];
                    }
                }
            }
        }
        return items;
    }

    






    invoke(method, ...params) {
        return this.widget[method](...params);
    }

    


    _cachePagingInit() {
        this._checkCachePagingMethod();
        if (this._xuxWidgetName === "xuxDecoratedTable") {
            
            
            this._itemsPerPage = this.options.itemsPerPage || XUX_DEFAULT_ITEMSPERPAGE;
            this._xuxPagesPerLoad = this.options.xuxPagesPerLoad || XUX_DEFAULT_PAGESPERLOAD;
            this._xuxPageCacheRate = this.xuxOptions.xuxPageCacheRate || 1;
            this._pagesPerLoad = this._xuxPagesPerLoad * this._xuxPageCacheRate;
            this.xuxOptions.itemsPerPage = this._itemsPerPage;
            this.xuxOptions.pagesPerLoad = this._xuxPagesPerLoad;
        }
        if (this._xuxWidgetName === "xuxTable") {
            this.xuxOptions.autoLoad = true;
        }
        this._maxLoadedCacheSize = this.options.maxLoadedCacheSize || 1;
        this._numberOfAllItems = 0;
        if (!this.options.fetch) {
            throw new Error("fetch is not defined in supportOptions");
        }
        this._fetch = this.options.fetch;
        if (this.xuxOptions.data !== undefined) {
            throw new Error("data function should not be defined in xuxOptions");
        }
        
        this.xuxOptions.data = this._data.bind(this);
        
        this._loadedItemsCache = {}; 
        this._loadedKeys = []; 
        this._loadPointers = {}; 
    }

    





    _checkCachePagingMethod() {
        this._cachePagingMethod = this.options.cachePagingMethod;
        if (!this._cachePagingMethod) {
            this._cachePagingMethod = (this._xuxWidgetName === "xuxTable") ? "noPaging" : "unindexed";
        } else if (!CACHE_PAGING_METHOD.includes(this._cachePagingMethod)) {
            throw new Error("wrong parameter with cachePagingMethod");
        } else if ((this._cachePagingMethod === "unindexed") && (this._xuxWidgetName === "xuxTable")) {
            throw new Error("xuxTable is not matached with cachePagingMethod of unindexed");
        }
    }

    


    _clearCache() {
        this._loadedItemsCache = {}; 
        this._loadedKeys = []; 
        this._loadPointers = {}; 
    }

    _normalizeData(data) {
        
        
        if (!data.listOfAttributes) {
            data = {
                listOfAttributes: data
            };
        }
        this._wrapItems(data.listOfAttributes.items);
        return data;
    }

    





    _data(params) {
        
        if (this._cachePagingMethod === "noCache") {
            
            return this._fetch({}, params).then(data => {
                data = this._normalizeData(data);
                if (this._xuxWidgetName === "xuxDecoratedTable") {
                    data.listOfAttributes.numberOfAllItems = data.listOfAttributes.items.length;
                }
                return this.processData(data.listOfAttributes, params);
            });
        }
        if (params.noCache === true) {
            
            this._clearCache();
        }
        let key = 0; 
        let fetchOptions = {};
        
        if (this._cachePagingMethod === "unindexed") {
            key = params.start / this._itemsPerPage / this._pagesPerLoad;
            fetchOptions.max = this._itemsPerPage * this._pagesPerLoad;
            fetchOptions.from = this._loadPointers[key] || null;
        }
        
        if ((this._loadedItemsCache[key]) && (this._loadedItemsCache[key].length > 0)) {
            return this._loadDataFromCache(key, params);
        }
        
        
        
        return this._fetch(fetchOptions, params).then(data => {
            data = this._normalizeData(data);
            if (this.options.dataFilter) {
                data.listOfAttributes.items = data.listOfAttributes.items.filter(
                    this.options.dataFilter);
            }
            return this._processCache(data, key, params);
        });
    }

    





    _wrapItems(items) {
        let len = items.length;
        let getIndex = name => {
            let idx = this.queryColumnKeyIdxs[name];
            if (idx === undefined) {
                let column = this.columns[name];
                if (!column) {
                    throw new Error("unknwon field name: " + name);
                }
                idx = this.queryColumnKeyIdxs[this.columns[name]._accessPath];
            }
            return idx;
        };
        for (let i = 0; i < len; i++) {
            let item = items[i];
            item.get = name => item[getIndex(name)];
            item.getOriginal = name => item.getOriginalByIdx(getIndex(name));
            item.getOriginalByIdx = idx => idx in item._original ? item._original[idx] : item[idx];
        }
    }

    






    _processCache(data, key, params) {
        
        this._loadedItemsCache[key] = data.listOfAttributes.items;
        let start = params.start;
        let fetchedItemsNum = data.listOfAttributes.items.length;
        
        this._updateNumberOfAllItems(start, fetchedItemsNum);


        
        if (this._cachePagingMethod === "noPaging") {
            return this._loadDataFromCache(key, params);
        }
        
        let keyPos = this._loadedKeys.indexOf(key);
        if (keyPos >= 0) {
            this._loadedKeys.splice(keyPos, 1); 
        }
        this._loadedKeys.push(key); 
        if (data.nextId) {
            if ((this._loadPointers[key + 1]) && (this._loadPointers[key + 1] !== data.nextId)) {
                
                for (let k of Object.keys(this._loadedItemsCache)) {
                    if (k > key) {
                        delete this._loadedItemsCache[k];
                    }
                }
            }
            this._loadPointers[key + 1] = data.nextId;
            
            if ((fetchedItemsNum % this._itemsPerPage) === 0 && this.nextClicked) {
                this._numberOfAllItems ++;
            }
        }
        
        if (this._loadedKeys.length > this._maxLoadedCacheSize) {
            let oldKey = this._loadedKeys.shift();
            delete this._loadedItemsCache[oldKey];
            delete this._loadPointers[oldKey];
        }
        
        return this._loadDataFromCache(key, params);
    }

    





    _loadDataFromCache(key, params) {
        let retData = {};
        retData.fields = this.queryColumnKeys;
        if (this._cachePagingMethod === "noPaging") {
            retData.items = this._loadedItemsCache[key];
        }
        if (this._cachePagingMethod === "unindexed") {
            let xuxCacheKey = params.start / this._itemsPerPage / this._xuxPagesPerLoad;
            let from = (xuxCacheKey % this._xuxPageCacheRate) *
                this._itemsPerPage * this._xuxPagesPerLoad;
            let to = from + (this._xuxPagesPerLoad * this._itemsPerPage);
            retData.items = this._loadedItemsCache[key].slice(from, to);
        }
        if (this._xuxWidgetName === "xuxDecoratedTable") {
            retData.numberOfAllItems = this._numberOfAllItems;
        }
        return this.processData(retData, params);
    }

    





    _updateNumberOfAllItems(start, fetchedItemsNum) {
        let currentPageNum = (start / this._itemsPerPage) + 1;
        let allItemsNum = (this._itemsPerPage * (currentPageNum - 1)) + fetchedItemsNum;
        this.nextClicked = false;
        if (allItemsNum > this._numberOfAllItems) {
            this._numberOfAllItems = allItemsNum;
            this.nextClicked = true;
        }
    }
}
module.exports = XuxTableSupport;

